import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../config/AuthProvider/authProvider";
import LayoutWithoutDrawer from "../../../layouts/LayoutWithoutDrawer";
import { ApiResultModel } from "../../../models/common.model";
import { IGetInProgressLoanTemplateResponse } from "../../../models/loan.model";
import { getNextState } from "../../../redux/handleBackBtn/handleBackBtnSlice";
import { getpervStateTab } from "../../../redux/loansTab/loansTabSlice";
import { RootState } from "../../../redux/store";
import { GetInProgressLoanTemplate } from "../../../services/loan.service";
import CreateNewRequest from "../../createNewRequest/createNewRequest";
import ContainerRegisterLoan from "./containerApp/containerApp";
import { TLoansContainer } from "./ILoansContainer";
import LoanDetail from "./loanDetail/loanDetail";
import InstallmentChequeContainer from "./Loans/cheques/installmentChequeContainer";
import InstallmentsContainer from "./Loans/cheques/installmentsContainer";
import Loans from "./Loans/loans";



export default function LoansContainer({ setTabChild }: { setTabChild: (id: number) => void }) {
    const dispatch = useDispatch();
    const stateRedux = useSelector((state: RootState) => state.loansTabComponents.prevState) as TLoansContainer
    const queryClient = useQueryClient()

    const isInProgress = JSON.parse(sessionStorage.getItem('HAS_INPROGRESS')!);
    const { setRefKey } = useAuth()
    const [inProgressLoanTemplate, setInProgressLoanTemplate] = useState<IGetInProgressLoanTemplateResponse | null>(null);
    const [isDataFetched, setDataFetched] = useState(false)
    const { mutate: GetInProgressLoanTemplateMutate } = useMutation(GetInProgressLoanTemplate, {
        onSuccess: (data: ApiResultModel<IGetInProgressLoanTemplateResponse>) => {
            setDataFetched(true)
            if (data.data) {
                setInProgressLoanTemplate(data.data);

            }
            if (data.messages.length > 0) {
                moveToLoanTemplateList()
            }
        },
        onError: () => {
            moveToLoanTemplateList()
        }
    });
    const moveToLoanTemplateList = () => {
        setDataFetched(false)
        dispatch(getpervStateTab({ prevState: 'appContainer' }))
        dispatch(getNextState({ nextState: `selectLoanTemplate` }))
    }

    const cleanUrl = () => {
        const newCleanUrl = `${window.location.origin}/#/`;
        window.history.replaceState(null, '', newCleanUrl);
    }
    useEffect(() => {
        //route from kaman
        const path = (window.location.href);
        const urlParams = new URLSearchParams(window.location.search);
        const target = urlParams.get("target")
        const loanTemplateKey = urlParams.get('loanTemplateKey')
        if (target && target.includes("registerLoan")) {
            const token = urlParams.get('token');

            setRefKey(null);
            dispatch(getpervStateTab({ prevState: 'appContainer' }))
            cleanUrl()
        }
        //route from kaman

        else if (target && target.includes("requestLoan") && loanTemplateKey) {
            GetInProgressLoanTemplateMutate({ loanTemplateKey });
        }
        else if (isInProgress?.inProgress) {
            dispatch(getpervStateTab({ prevState: 'appContainer' }))
        }
        // check all form states
        else if (target && target.includes("loans")) {
            dispatch(getpervStateTab({ prevState: 'loans' }))
        }
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        metaThemeColor!.setAttribute('content', '#fff');
    }, [])

    useEffect(() => {
        if (isDataFetched) {
            const urlParams = new URLSearchParams(window.location.search);
            const loanTemplateKey = urlParams.get('loanTemplateKey')
            queryClient.setQueryData('LOAN_TEMPLATE_KEY', loanTemplateKey)
            if (!loanTemplateKey) return
            if (inProgressLoanTemplate?.hasMany) {
                dispatch(getpervStateTab({ prevState: 'loans' }))
                cleanUrl()
            } else if (inProgressLoanTemplate?.loanRequestStatus) {
                dispatch(getpervStateTab({ prevState: 'appContainer' }))
                cleanUrl()
            } else if (!inProgressLoanTemplate) {
                dispatch(getpervStateTab({ prevState: 'appContainer' }))
                dispatch(getNextState({ nextState: `confirmLoanTemplate` }))
                cleanUrl()
            }
        }
    }, [inProgressLoanTemplate, isDataFetched])

    const currentState = {
        'loans': <Loans />,
        'loanDetail': <LoanDetail />,
        'appContainer': <ContainerRegisterLoan setTabChild={setTabChild} refKey={inProgressLoanTemplate?.referenceKey!} />,
        'installment': <InstallmentsContainer />,
        'InstallmentCheque': <InstallmentChequeContainer />,
        'registerLoan': <LayoutWithoutDrawer>
            <CreateNewRequest />
        </LayoutWithoutDrawer>

    }

    return (
        <div>
            {currentState[stateRedux!]}
        </div>
    )
}
